import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7abba14a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  class: "reserve-page",
  id: "reserve-page"
}
const _hoisted_3 = { class: "detail-page-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "service-map-box",
  id: "service-map-box"
}, null, -1))
const _hoisted_5 = { class: "map-list" }
const _hoisted_6 = { class: "service-msg" }
const _hoisted_7 = { class: "service-item" }
const _hoisted_8 = { class: "service-name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-phone",
  src: "/images/icon_dianhua.svg"
}, null, -1))
const _hoisted_10 = { class: "service-address" }
const _hoisted_11 = {
  key: 1,
  class: "xag-page__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_device_footer = _resolveComponent("device-footer")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_app_header, {
          title: "选择维修网点",
          rightTxt: "确定",
          rightCanClick: !!_ctx.selectAddress,
          onRightClick: _ctx.handleRightClick,
          isReturnLeftEvent: true,
          onLeftClick: _ctx.handleBack
        }, null, 8, ["rightCanClick", "onRightClick", "onLeftClick"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_search, {
          background: "#F6F7F8",
          class: "search-box",
          modelValue: _ctx.searchValue,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
            _ctx.handleSearch
          ],
          placeholder: "请输入关键词"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_van_list, {
          class: "map-list-box",
          loading: _ctx.listLoading,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listLoading) = $event)),
          finished: _ctx.listFinished,
          offset: "100",
          direction: "down",
          "finished-text": "没有更多了",
          onLoad: _ctx.listOnLoad
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_radio_group, {
              modelValue: _ctx.selectAddress,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectAddress) = $event)),
              onChange: _ctx.handleChangeAddress
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "map-item",
                    key: index
                  }, [
                    _createVNode(_component_van_radio, {
                      class: "map-item-radio",
                      name: item,
                      "checked-color": "#00C378"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1),
                            _hoisted_9
                          ]),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.calculDistance(item.distance)) + " | " + _toDisplayString(item.address), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      (_ctx.isMiniProgram)
        ? (_openBlock(), _createBlock(_component_device_footer, {
            key: 0,
            title: "确定",
            isCanClick: !!_ctx.selectAddress,
            onFooterSubmit: _ctx.handleRightClick
          }, null, 8, ["isCanClick", "onFooterSubmit"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11))
    ])
  ]))
}